<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <Loading v-if="validatingToken" />
    <transition name="slide" mode="out-in">
      <Auth v-if="!user" />
    </transition>
    <Header v-if="user" />
    <div
      class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body"
      v-if="user"
    >
      <Leftbar />
      <Content v-if="!validatingToken" />
    </div>
    <Footer v-if="user" />
  </div>
</template>

<script>
import axios from 'axios';
import { baseApiUrl, userKey, localStorageVersion } from '@/global';
import { mapState } from 'vuex';
import Auth from '@/components/auth/Auth';
import Header from '@/components/template/Header';
import Leftbar from '@/components/template/Leftbar';
import Content from '@/components/template/Content';
import Footer from '@/components/template/Footer';
import Loading from '@/components/template/Loading';

export default {
  name: 'App',
  components: { Auth, Header, Leftbar, Content, Footer, Loading },
  computed: mapState(['user']),
  data() {
    return {
      validatingToken: false,
    };
  },
  methods: {
    async validateToken(userData) {
      userData = userData || {};
      this.validatingToken = true;

      axios.defaults.headers.common.Authorization = `Bearer ${userData.token}`;
      axios
        .get(`${baseApiUrl}/validateToken`)
        .then((res) => {
          if (!res.data.success) {
            this.$store.commit('setContaAzulAuthorized', false);
          }
        })
        .catch((data) => {
          if (data.response.status === 401) {
            localStorage.removeItem(userKey);
            this.$store.commit('setUser', null);
            this.$store.commit('setContaAzulAuthorized', false);
            this.$router.push({ name: 'auth' });
          }
        });

      this.validatingToken = false;
    },
  },
  created() {
    if (
      !this.$store.getters.currentStorageVersion ||
      this.$store.getters.currentStorageVersion !== localStorageVersion
    ) {
      this.$store.commit('setLocalStorageVersion', localStorageVersion);
      this.$store.commit('setUser', null);
      this.$store.commit('setUserScope', null);
      this.$store.commit('setToken', null);
      this.$store.commit('setContaAzulAuthorized', false);
    } else {
      const userData = this.$store.getters.currentUser;
      this.$store.getters.currentToken;
      this.$store.getters.currentScope;
      if (!this.$route.meta.public) {
        this.validateToken(userData);
      }
    }
  },
};
</script>

<style>
/* Fade */
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.fade-enter-active {
  animation: fade-in 0.3s ease;
}

.fade-leave-active {
  animation: fade-out 0.3s ease;
}

/* Slide Up */
@keyframes slide-in {
  from {
    transform: translateY(-30px);
    opacity: 0;
  }
  to {
    transform: translateY(0px);
    opacity: 1;
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0px);
    opacity: 1;
  }
  to {
    transform: translateY(-30px);
    opacity: 0;
  }
}

.slide-enter-active {
  animation: slide-in 0.3s ease;
}

.slide-leave-active {
  animation: slide-out 0.3s ease;
}

/* Slide Left */
@keyframes slideleft-in {
  from {
    transform: translateX(200px);
    opacity: 0;
  }
  to {
    transform: translateX(0px);
    opacity: 1;
  }
}

@keyframes slideleft-out {
  from {
    transform: translateX(0px);
    opacity: 1;
  }
  to {
    transform: translateX(200px);
    opacity: 0;
  }
}

.slideleft-enter-active {
  animation: slideleft-in 0.3s ease;
}

.slideleft-leave-active {
  animation: slideleft-out 0.5s ease;
}
</style>
